import 'classlist-polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SagaProvider } from 'react-async-client';
import { PersistGate } from 'redux-persist/es/integration/react';
import { compose, join, last, map, omit, replace, split, tail } from 'ramda';
import 'yup';
import 'experium-player';

import rollbarInit from 'utils/rollbarInit';

import '../styles/vendor.less';
import '../styles/styles.less';
import '../styles/colorSchemes/dark.less';

import * as actions from 'actions/asyncActions';

import { Store, Persistor, sagaMiddleware } from 'store';
import 'utils/yupMethods';

import App from './App';

import { provideResponseInterceptors, provideRequestInterceptors } from 'utils/httpInterceptors';
import { setBaseUrl } from 'utils/http';
import { isRollbarInit } from 'utils/rollbar';

provideResponseInterceptors();
provideRequestInterceptors();
setBaseUrl();

ReactDOM.render(
    <SagaProvider sagaMiddleware={sagaMiddleware}>
        <Provider store={Store}>
            <PersistGate persistor={Persistor}>
                <App />
            </PersistGate>
        </Provider>
    </SagaProvider>,
    document.getElementById('root')
);

if (isRollbarInit) {
    const omitWebCatalog = compose(join('.'), tail, split('.'));
    const hosts = process.env.ROLLBAR_HOST.split(',');
    const pickStore = omit(['asyncClient', 'modules']);

    rollbarInit({
        token: '4bb342cfdc174f34ad3daf31fe6814ee',
        version: process.env.revision,
        sourceHost: last(hosts),
        getPayload: () => pickStore(Store.getState()),
        getPerson: () => actions.getUser.selectData(Store.getState()),
        environment: omitWebCatalog(window.location.host),
        domains: map(
            replace(/https?:\/\//i, '.*?\\.'),
            hosts
        )
    });

    window._version = {
        version: process.env.revision,
        build: process.env.version,
        date: process.env.date,
    };
}
